module.exports = __webpack_public_path__ + "img/marker_one_cyan3.96411b1d.png";